import {useParams, useRouteMatch} from 'react-router-dom';
import {UserApplications} from '../../../../../../../components/user-applications/user-applications';
import {CaregiverMode} from '../../../../../../../enums/caregiver-mode';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../../../../../i18n/translations';
import {ScreenPaths} from '../../../../../../../enums';
import {CaregiverPathExtensions} from '../../../../../../../components/caregiver-routes/caregiver-routes';
import {useOffice} from '../../../../../../../contexts/office/context';

export default function ProfessionalCaregiverApplicationsProfessionalCaregiverOfficeScreen({
  canWrite,
}: {
  canWrite: boolean;
}) {
  const officeContext = useOffice();
  let {id, entityId}: {id?: string; entityId?: string} = useParams();
  const {t} = useTranslation();
  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  const {url} = useRouteMatch();

  return (
    <UserApplications
      caregiverMode={CaregiverMode.Professional}
      userId={id || ''}
      userName={
        officeContext.state.userForm?.user.displayName ||
        officeContext.state.userForm?.user.name ||
        ''
      }
      entityId={entityId}
      canWrite={canWrite}
      applicationRowBaseLinkUrl={url}
      headerTitleCrumbs={[
        {
          label: t(
            translations.office.professional_caregiver.profile.generic_header.breadcrumbs.team
          ),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_ProfessionalCaregivers}`,
        },
        {
          label: t(
            translations.office.professional_caregiver.profile.generic_header.breadcrumbs
              .professionals
          ),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_ProfessionalCaregivers}`,
        },
        {
          label:
            officeContext.state.userForm?.user.displayName ||
            officeContext.state.userForm?.user.name ||
            '',
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_ProfessionalCaregivers}/${id}/${CaregiverPathExtensions.Profile}`,
        },
        {
          label: t(translations.screen_paths.senior_applications),
          link: url,
        },
      ]}
    />
  );
}
